import React from "react";

import Legal from "../../views/layouts/Legal";
import Cookies from "../../views/pages/dashboard/legal/Cookies";
import Disclaimer from "../../views/pages/dashboard/legal/Disclaimer";
import Notice from "../../views/pages/dashboard/legal/Notice";
import Privacy from "../../views/pages/dashboard/legal/Privacy";
import Terms from "../../views/pages/dashboard/legal/Terms";
import TncDistributor from "../../views/pages/dashboard/legal/TncDistributor";
import TncPartner from "../../views/pages/dashboard/legal/TncPartner";
import TncReferrer from "../../views/pages/dashboard/legal/TncReferrer";

const subRoutes = [
  {
    path: "tnc-partner",
    component: <TncPartner />,
  },
  {
    path: "tnc-referrer",
    component: <TncReferrer />,
  },
  {
    path: "tnc-distributor",
    component: <TncDistributor />,
  },
  {
    path: "notice",
    component: <Notice />,
  },
  {
    path: "cookies",
    component: <Cookies />,
  },
  {
    path: "privacy",
    component: <Privacy />,
  },
  {
    path: "terms",
    component: <Terms />,
  },
  {
    path: "disclaimer",
    component: <Disclaimer />,
  },
];

const index = () => ({
  path: "/legal",
  component: <Legal />,
  subRoutes: subRoutes,
});

export default index;
